<template>
	<div class="index-split2-calender-news row">
		<div class="video rwd-m-7 col">
			<carousel
				ref="carousel"
				:options="{ duration: 1000, loop: true }"
				@change="(val) => (currentSlide = val)"
			>
				<div v-for="(item, i) in list" class="col" :key="i">
					<p class="video-title">{{ item.title }}</p>
					<ratio>
						<iframe :src="item.video" allowfullscreen frameborder="0" />
					</ratio>
				</div>
			</carousel>
			<div class="row-grid" align-x="around" align-y="center">
				<div class="row" style="padding: 1em">
					<template v-for="i in (list && list.length) || 0">
						<i
							class="indicator"
							:class="{ active: currentSlide == i - 1 }"
							@click="$refs['carousel'].goTo(i - 1)"
							:key="i"
						/>
					</template>
				</div>
				<div class="row" gutter="20" style="padding: 1em">
					<button @click="$refs['carousel'].prev()">
						<img src="@/assets/home/left.png" height="20" />
					</button>
					<button @click="$refs['carousel'].next()">
						<img src="@/assets/home/right.png" height="20" />
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "indexSplit2CalenderNews",
	components: {
		Carousel: () => import("./Carousel"),
		Ratio: () => import("./Ratio"),
	},
	data() {
		return {
			isShowPop: false,
			currentPop: {},
			currentSlide: 0,
			list: [
				{
					video:
						"https://www.youtube.com/embed/s7pwTc-iBJA?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2024 《蓄勢創造》Open Lab 精彩回顧｜利澤國際偶戲藝術村－駐村藝術家計畫｜AIR Program of Lize Puppet Art Colony",
					date: "2024年11月27日",
				},
				{
					video:
						"https://www.youtube.com/embed/jYBVJkMFlns?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2023《重啟連結Reconnect》Open Lab 精彩回顧",
					date: "2023年11月29日",
				},
				{
					video:
						"https://www.youtube.com/embed/e6HCHLCeEa4?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2022 社區劇場《媽祖不在家》精彩回顧",
					date: "2022年6月26日",
				},
				{
					video:
						"https://www.youtube.com/embed/k_lfRlUWiic?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2021《非比尋常》駐村藝術家成果展 精彩回顧",
					date: "2024年4月19日",
				},
				{
					video:
						"https://www.youtube.com/embed/aehuYHuUHfA?rel=0&amp;controls=0&amp;showinfo=0",
					title:
						"2020駐村藝術家「驚喜偶遇」Artist-in-Residence of Lize Puppet Art Colony 2020",
					date: "2020年12月28日",
				},
				{
					video:
						"https://www.youtube.com/embed/tEoeD1wZ-tQ?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2020利澤老街動起來",
					date: "2020年12月9日",
				},
				{
					video:
						"https://www.youtube.com/embed/O1H--zjhrXs?rel=0&amp;controls=0&amp;showinfo=0",
					title:
						"2019駐村藝術家「偶藝不設限」Artist-in-Residence of Lize Puppet Art Colony",
					date: "2019年12月12日",
				},
				{
					video:
						"https://www.youtube.com/embed/MpUo6h8LZgA?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2018 利澤國際偶戲藝術村「偶藝不設限」駐村藝術家計畫",
					date: "2018年12月24日",
				},
				{
					video:
						"https://www.youtube.com/embed/iD763iCXGWE?rel=0&amp;controls=0&amp;showinfo=0",
					title: "2018利澤偶聚祭Lize International Puppet Festival-精彩回顧",
					date: "2018年12月9日",
				},
				// {
				// 	video: "https://www.youtube.com/embed/Rb2ujxEkMp4?rel=0&amp;controls=0&amp;showinfo=0",
				// 	title: "2017利澤偶聚祭 回顧影片",
				// 	date: "2018年3月20日"
				// },
				// {
				// 	video: "https://www.youtube.com/embed/uk8vWd0Z_vE?rel=0&amp;controls=0&amp;showinfo=0",
				// 	title: "2017【讀偶時光】_十月號．世界當代偶戲藝術系列：來自墨西哥的勇氣媽媽",
				// 	date: "2017年10月27日"
				// },
				// {
				// 	video: "https://www.youtube.com/embed/u6is9nhWEEs?rel=0&amp;controls=0&amp;showinfo=0",
				// 	title: "2017【讀偶時光】_ 九月號．與偶相遇",
				// 	date: "2017年9月30日"
				// },
			],
		};
	},
	methods: {
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		closeSlide() {
			this.isShowPop = false;
		},
		openSlide: function (data) {
			this.currentPop = data;
			this.isShowPop = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.col {
	padding: 0;
}
.row {
	margin: 0;
}
.index-split2-calender-news {
	display: flex;
	justify-content: center;
}
.video {
	max-width: 800px;
	margin-top: 20px;
	.carousel {
		p {
			color: #fff;
			padding: 1em;
			background: #062b51;
			font-size: 1.2em;
		}
		iframe {
			position: absolute;
			width: 100%;
			height: 100%;
		}
	}
	button {
		border-radius: 100px;
		background: #01b6e2;
		border: none;
		padding: 0.5em 2em;
	}
}
.indicator {
	width: 10px; // use px when browser not support rem
	height: 10px; // use px when browser not support rem
	width: 0.625rem;
	height: 0.625rem;
	cursor: pointer;
	transition: 0.3s;
	border-radius: 100%;
	background: transparent;
	border: 1px solid #01b6e2;
	&:not(:first-child) {
		margin-left: 10px; // use px when browser not support rem
		margin-left: 0.625rem;
	}

	&:hover,
	&.active {
		background: #01b6e2;
		transform: scale(1.2);
	}
}
.video-title {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/index_split2_calender_news.vue